// Classement d'un dossier « sans suite » : motifs (codes stables en base) et libellés, partagés par le serveur et l'interface.
export const MOTIFS_CLASSEMENT = ['abandon_client', 'marche_perdu', 'client_difficulte', 'demo_terminee', 'autre'] as const;
export type MotifClassement = typeof MOTIFS_CLASSEMENT[number];

export const LIBELLES_MOTIF: Record<MotifClassement, string> = {
  abandon_client: 'Abandon du client',
  marche_perdu: 'Marché perdu',
  client_difficulte: 'Client en difficulté',
  demo_terminee: 'Démonstration terminée',
  autre: 'Autre',
};

/** Longueur maximale du commentaire de classement (même borne que la base). */
export const COMMENTAIRE_MAX = 500;

/** Confirmation d'effacement : la saisie doit reprendre la référence du dossier (ou son titre exact), espaces et casse ignorés aux bords. */
export function confirmationValide(saisie: string, dossier: { reference: string; title: string }) {
  const s = saisie.trim();
  if (!s || s.length > 400) return false;
  return s.toLowerCase() === dossier.reference.trim().toLowerCase() || s === dossier.title.trim();
}
